export const ErrorMessageResolver = {
  resolve: (err) => {
    if (err?.response?.data) {
      const { data, status } = err.response;

      if (data.error === "unauthorized") {
        if (data.error_description === "User not enabled") {
          return data.error_description;
        }
        return "Authentication required or invalid credentials.";
      }

      if (data.error === "invalid_grant") {
        return "Bad credentials.";
      }

      if (data.message?.includes("Could not get JDBC Connection;")) {
        return "Could not get JDBC Connection.";
      }

      switch (status) {
        case 400:
          if (typeof data === "string") {
            return data || "Unexpected error occured.";
          }
          return data && data?.message
            ? data?.message
            : data
            ? data
            : "Bad request.";
        case 401:
          return "Connection error: Unauthorized access.";
        case 403:
          return "Access denied.";
        case 404:
          return "Data not found.";
        case 500:
          return data && data?.message
            ? data?.message
            : data
            ? data
            : "Internal server error.";
        default:
          if (status) {
            return `Server error: Status ${status}.`;
          }
      }
    }

    if (err.message === "Network Error") {
      return "Network Error";
    }

    return "An unexpected connection error occurred.";
  },
};
